// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230107/js/" + chunkId + "." + {"44":"e010cbc5","225":"1a51ac89","481":"cad5483c","486":"76b07b8e","770":"4423749a"}[chunkId] + ".0.37071067833702087.chunk.js";
};